import {
    Box,
    Grid,
    Theme,
    Typography
} from '@mui/material';
import { Demat } from '../../redux-store/types/api-types';
import { KeyValue } from './personalDetails';
import { SubHeading } from '../investors/components';
import { Fragment } from 'react';

export default function DematDetails({ demats = [] }: { demats: Partial<Demat>[] }): JSX.Element {
    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: theme.palette.common.white,
                    boxShadow: `0px 4px 12px ${theme.palette.common.black}1A`,
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: '25px',
                })}
                mt={5}>
                <Box>
                    <Grid container >
                        <Typography
                            variant='body_700'
                            sx={(theme: Theme) => ({
                                color: theme.palette.primary[900],
                                mb: '9px'
                            })}>
                            Investor&apos;s DP Details
                        </Typography>
                        {demats.length === 0 ? (
                            <Grid
                                xs={12}
                                sm={12}
                                sx={{ my: 1.5 }}
                            >
                                <Typography
                                    variant='body_500'
                                    sx={{
                                        color: 'text.primary',
                                        textAlign: 'center',
                                        fontWeight: 600
                                    }}
                                >
                                    No DP Details
                                </Typography>
                            </Grid>
                        ) : (
                            demats.map((demat: Demat, index: number) => {
                                return (
                                    <Fragment key={demat.id}>
                                        <SubHeading sx={{ letterSpacing: "0.02px" }}>{`DP Account ${index + 1} Details`}</SubHeading>
                                        <Grid
                                            item
                                            container
                                            rowSpacing={3}
                                            columnSpacing={5.5}
                                            direction="row"
                                        >
                                            <KeyValue
                                                title='Depository Name'
                                                description={demat?.depositoryName ?? ""}
                                            />
                                            <KeyValue
                                                title='DP Name'
                                                description={demat?.dpName ?? ""}
                                            />
                                            <KeyValue
                                                title='DP ID'
                                                description={demat?.dpId ?? ""}
                                            />
                                            <KeyValue
                                                title='Client ID'
                                                description={demat?.clientId ?? ""}
                                            />
                                            <KeyValue
                                                title='Default DP Detail'
                                                description={demat?.defaultDematAccount ? 'Yes' : '-'}
                                            />
                                        </Grid>
                                    </Fragment>
                                );
                            })
                        )}
                    </Grid>
                </Box>
            </Box >
        </>
    );
}
